<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6BNsRR/tc-custom/9781429954617.jpg?1737764882813" alt="This image is the cover for the book Ha'penny, Small Change"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ha'penny, Small Change
      </h1>
      <p class="bookDescription body article font2">
        <b>In this alternative history detective thriller, a conspiracy is brewing within fascist England to assassinate the Nazi-aligned Prime Minister.</b><br/><br/><i>England, 1949</i>. It’s been eight years since Great Britain negotiated a truce with Nazi Germany. England has slid into fascist dictatorship. And now a bomb has exploded in a London suburb. As Inspector Carmichael of Scotland Yard investigates, he uncovers a conspiracy of peers and communists, of staunch King-and-Country patriots and hardened IRA gunmen, to murder Britain’s Prime Minister and his new ally, Adolf Hitler.<br/><br/>Against a background of domestic espionage and the suppression of Jews and homosexuals, an ad-hoc band of idealists and conservatives blackmail the one person they need to complete their plot, an actress who lives for her art and holds the key to the Fuhrer’s death. From the ha’penny seats in the theatre to the ha’pennies that cover dead men’s eyes, the conspiracy and the investigation swirl around one another, spinning beyond anyone’s control.<br/><br/>In this sequel to <i>Farthing</i>, Welsh-born World Fantasy Award winner Jo Walton continues her alternate history of an England that could have been, with a novel that is both an homage of the classic detective novels of the thirties and forties, and an allegory of the world we live in today.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jo Walton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c29b712a